import axios from "axios";
import env from "../env";

const api_url = env.API_URL;

export const addAssignmentFilePath = async (body:any, token: string) => {
    try {
        const response = await axios.post(`${api_url}assignments/file-path`,body, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteAssignmentFilePath = async (id:any, token: string) => {
    try {
        const response = await axios.delete(`${api_url}assignments/file-path?id=${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteAssignment = async (id:any, token: string) => {
    try {
        const response = await axios.delete(`${api_url}assignments/material?id=${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const addAssignment = async (body:any, token: string) => {
    try {
        const response = await axios.post(`${api_url}assignments/material`,body, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const addAnswers = async (body:any,assignmentId:any, userId:any, token: string) => {
    try {
        const response = await axios.post(`${api_url}assignments?MaterialAssignmentId=${assignmentId}&UserId=${userId}`,body, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateUploadStatus = async (body:any, token: string) => {
    try {
        const response = await axios.post(`${api_url}assignments/material/update-status`,body, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getAssignmentPaths = async (programme: string, stream: string, subject: string, token: string) => {
    try {
        const response = await axios.get(`${api_url}assignments/file-path`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                programme,
                stream,
                subject
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getAssignment = async (id:any,fileId:any,token:any) => {
    try {
        const response = await axios.get(`${api_url}assignments/material?id=${id}&filePathId=${fileId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getSubmissions = async (userId:any,assignmentId:any,token:any) => {
    try {
        const response = await axios.get(`${api_url}assignments?userId=${userId}&materialAssignmentId=${assignmentId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getMarks = async (programme:string, stream:string,userId:any,token:any) => {
    try {
        const response = await axios.get(`${api_url}assignments/marks?programme=${programme}&stream=${stream}&userId=${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}
